/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CartItems} from './CartItems';

/**
 * The CartValidationRequestCart model module.
 * @module model/CartValidationRequestCart
 * @version v1
 */
export class CartValidationRequestCart {
  /**
   * Constructs a new <code>CartValidationRequestCart</code>.
   * @alias module:model/CartValidationRequestCart
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CartValidationRequestCart</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CartValidationRequestCart} obj Optional instance to populate.
   * @return {module:model/CartValidationRequestCart} The populated <code>CartValidationRequestCart</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CartValidationRequestCart();
      if (data.hasOwnProperty('collection_date'))
        obj.collection_date = ApiClient.convertToType(data['collection_date'], 'String');
      if (data.hasOwnProperty('discount_code'))
        obj.discount_code = ApiClient.convertToType(data['discount_code'], 'String');
      if (data.hasOwnProperty('items'))
        obj.items = CartItems.constructFromObject(data['items']);
      if (data.hasOwnProperty('requires_shipping'))
        obj.requires_shipping = ApiClient.convertToType(data['requires_shipping'], 'Boolean');
      if (data.hasOwnProperty('shipping_lat'))
        obj.shipping_lat = ApiClient.convertToType(data['shipping_lat'], 'String');
      if (data.hasOwnProperty('shipping_lon'))
        obj.shipping_lon = ApiClient.convertToType(data['shipping_lon'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} collection_date
 */
CartValidationRequestCart.prototype.collection_date = undefined;

/**
 * @member {String} discount_code
 */
CartValidationRequestCart.prototype.discount_code = undefined;

/**
 * @member {module:model/CartItems} items
 */
CartValidationRequestCart.prototype.items = undefined;

/**
 * @member {Boolean} requires_shipping
 */
CartValidationRequestCart.prototype.requires_shipping = undefined;

/**
 * @member {String} shipping_lat
 */
CartValidationRequestCart.prototype.shipping_lat = undefined;

/**
 * @member {String} shipping_lon
 */
CartValidationRequestCart.prototype.shipping_lon = undefined;

